import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { _ } from 'vue-underscore';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Daftar Stok Keluar',
    title_form: 'Form Stok Keluar',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Stok Keluar',
        href: '/adm/logistic/stok-keluar',
        active: true,
      },
    ],
    tab: [
      {
        name: 'Supplier',
        active: true,
      },
      {
        name: 'Kode Akun dan HPP',
        active: false,
      },
    ],
    formProduct: {
      name: '',
      stock: '',
      min_stock: '',
      unit: '',
      price_buy: '',
      price_sale: '',
      brand: '',
      supplier_product: [
        {
          id_supplier: '',
          name_supplier: '',
          price_buy: '',
          disc: '',
          ppn: '',
          price_final: '',
        },
        {
          id_supplier: '',
          name_supplier: '',
          price_buy: '',
          disc: '',
          ppn: '',
          price_final: '',
        },
      ],
    },
    items: [
      {
        id: 1,
        kode: 'KS00121090001',
        purchase_no: 'PO00121090001',
        supplier: 'PT AMERTA INDAH JAYA',
        tgl_beli: '2021-09-01',
        tgl_keluar: '2021-09-01',
        pic: 'Andi',
        unit: '3-18',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        uang_muka: 1000000,
        sisa_hutang: 3200000,
        status: 'not paid',
        jenis: 'jasa',
        kode_produk: 'B1101',
        produk: 'Solar',
        satuan: 'liter',
        qty: 5,
        merk: 'Kenko',
      },
      {
        id: 2,
        kode: 'KS00121090002',
        purchase_no: 'PO00121090001',
        supplier: 'PT SEJAHTERA JAYA',
        tgl_beli: '2021-09-01',
        tgl_keluar: '2021-09-01',
        pic: 'Anton',
        unit: '10-18',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        uang_muka: 1000000,
        sisa_hutang: 3200000,
        status: 'paid',
        jenis: 'produk',
        kode_produk: 'B1102',
        produk: 'Solar',
        satuan: 'liter',
        qty: 3000,
        merk: 'Pertamina',
      },
      {
        id: 3,
        kode: 'KS00121090003',
        purchase_no: 'PO00121090001',
        supplier: 'PT TIRTA JAYA',
        tgl_beli: '2021-09-01',
        tgl_keluar: '2021-09-01',
        pic: 'Budi',
        unit: '5-20',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        uang_muka: 1000000,
        sisa_hutang: 3200000,
        status: 'paid',
        jenis: 'jasa',
        kode_produk: 'B1103',
        produk: 'Solar',
        satuan: 'liter',
        qty: 100,
        merk: 'Sinar Dunia',
      },
    ],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'kode',
        label: 'Stok No',
        sortable: true,
      },
      {
        key: 'unit',
        label: 'Unit',
        sortable: true,
      },
      {
        key: 'tgl_keluar',
        label: 'Tgl Keluar',
        sortable: true,
      },
      {
        key: 'pic',
        label: 'PIC',
        sortable: true,
      },
      {
        key: 'kode_produk',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'produk',
        label: 'Produk',
      },
      {
        key: 'qty',
        label: 'Jumlah',
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
      {
        key: 'merk',
        label: 'Merk',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
  },
};

export const getters = {
  form(state) {
    return state.data.formProduct;
  },
  activeTab(state) {
    let tabActive = _.findWhere(state.data.tab, {
      active: true,
    });

    return tabActive ? tabActive.name : '';
  },
};

export const mutations = {
  changeStokKeluar(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchCustomer(context, params = null) {
    let result = await ApiGetRequest(`logistic/suppliers`, params);
    return !result.error ? result.data.object : [];
  },

  async getListCustomer({ commit, state }) {
    commit('changeStokKeluar', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      _limit: data.limit,
      _page: data.page,
      _sort: data.sortBy,
      _order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/suppliers`, params);
    commit('changeStokKeluar', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailCustomer({ commit }, payload = null) {
    commit('changeStokKeluar', {
      loading: true,
    });

    let result = await ApiGetRequest(`logistic/suppliers/${payload.id}`);
    commit('changeStokKeluar', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async createCustomer({ commit, state, dispatch }) {
    commit('changeStokKeluar', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/suppliers`, state.data.form);
    commit('changeStokKeluar', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCustomer({ commit, state, dispatch }, payload = null) {
    commit('changeStokKeluar', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/suppliers/${payload.id}`,
      state.data.form
    );

    commit('changeStokKeluar', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCustomer({ commit, dispatch }, payload = null) {
    commit('changeStokKeluar', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/suppliers/${payload.id}`);
    commit('changeStokKeluar', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
